import PropTypes from 'prop-types';
import React from 'react';
import diff from 'object-diff';
import PropertyDetailsView from './PropertyDetailsView';
import PropertyDetailsForm from './PropertyDetailsForm';
import moment from 'moment';

function getInitialValues(hotel) {
  console.log('PropertyDetailsForm -> getInitialValues')
  const initialValues = hotel;
  initialValues.tax_rate = (hotel.tax_rate && hotel.tax_rate < 1)
    ? Number(hotel.tax_rate * 100.0).toFixed(3)
    : hotel.tax_rate;
    let today = new Date()
    let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    
  initialValues.year_built = hotel.year_built ? hotel.year_built : date //moment(date).format('YYYY-MM-DD');  
  initialValues.year_remodeled = hotel.year_remodeled ? hotel.year_remodeled : date //moment(date).format('YYYY-MM-DD');
  return initialValues;
}

class PropertyDetails extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditing: false,
      restaurantDisableClassName: '',
      gymDisableClassName: '',
      barDisableClassName: '', 
      roomServiceDisableClassName: ''
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRestaurantDisable = this.handleRestaurantDisable.bind(this);
    this.handleBarDisable = this.handleBarDisable.bind(this);
    this.handleGymDisable = this.handleGymDisable.bind(this);
    this.handleRoomServiceDisable = this.handleRoomServiceDisable.bind(this);
  }
  componentDidMount(){
    if(this.props.hotel.is_24hours_restaurant) {
      this.setState({restaurantDisableClassName: 'restaurant-hours-disable'})
    }
    if(this.props.hotel.is_24hours_bar) {
      this.setState({barDisableClassName: 'restaurant-hours-disable'})
    }
    if(this.props.hotel.is_24hours_gym) {
      this.setState({gymDisableClassName: 'restaurant-hours-disable'})
    }
    if(this.props.hotel.is_24hours_room_service) {
      this.setState({roomServiceDisableClassName: 'restaurant-hours-disable'})
    }
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  handleSubmit(values) {
    if (moment.isMoment(values.year_built)) {
      //values.year_built = year_built.format('YYYY-MM-DD');
      values.year_built = moment(values.year_built.toDate()).format('YYYY-MM-DD')
    }
    if (moment.isMoment(values.year_remodeled)) {
      values.year_remodeled = moment(values.year_remodeled.toDate()).format('YYYY-MM-DD')
    }  
    let changedValues = diff(this.props.hotel, values);
    changedValues.year_built = values.year_built
    changedValues.year_remodeled = values.year_remodeled
    console.log('property details handleSubmit called')
    if (changedValues.tax_rate) {
      changedValues.tax_rate = Number(changedValues.tax_rate / 100.0).toFixed(6);
    }
    this.props.editHotel(this.props.isAddHotel ? this.props.hotel.hotels[0].id :this.props.hotel.id, changedValues);
    this.handleClose();
  }
  handleRestaurantDisable(e){
    if(e.target.checked){
      this.setState({
        restaurantDisableClassName: 'restaurant-hours-disable'
      })
    }else{
      this.setState({
        restaurantDisableClassName: ' '
      })
    }
  }
  handleBarDisable(e){
    if(e.target.checked){
      this.setState({
        barDisableClassName: 'restaurant-hours-disable'
      })
    }else{
      this.setState({
        barDisableClassName: ' '
      })
    }
  }
  handleGymDisable(e){
    if(e.target.checked){
      this.setState({
        gymDisableClassName: 'restaurant-hours-disable'
      })
    }else{
      this.setState({
        gymDisableClassName: ' '
      })
    }
  }
  handleRoomServiceDisable(e){
    if(e.target.checked){
      this.setState({
        roomServiceDisableClassName: 'restaurant-hours-disable'
      })
    }else{
      this.setState({
        roomServiceDisableClassName: ' '
      })
    }
  }
  render() {
    if (this.state.isEditing || this.props.isAddHotel) {
      return (
        <PropertyDetailsForm
          {...this.props}
          onSubmit={this.handleSubmit}
          handleEdit={this.handleEdit}
          initialValues={getInitialValues(this.props.hotel)}
          handleClose={this.handleClose}
          restaurantDisableClassName={this.state.restaurantDisableClassName}
          barDisableClassName={this.state.barDisableClassName}
          gymDisableClassName={this.state.gymDisableClassName}
          roomServiceDisableClassName={this.state.roomServiceDisableClassName}
          handleRestaurantDisable={this.handleRestaurantDisable}
          handleBarDisable={this.handleBarDisable}
          handleGymDisable={this.handleGymDisable}
          handleRoomServiceDisable={this.handleRoomServiceDisable}
        />
      );
    }
    return <PropertyDetailsView {...this.props} handleEdit={this.handleEdit} />;
  }
}
PropertyDetails.propTypes = {
  hotel: PropTypes.object.isRequired,
  editHotel: PropTypes.func.isRequired,
};

export default PropertyDetails;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyDetails.js